import React, { lazy, useEffect } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
// import { themeChange } from 'theme-change'
import checkAuth from "./app/auth";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
// Importing pages
const Layout = lazy(() => import("./containers/Layout"));
const Login = lazy(() => import("./pages/Login"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
const Register = lazy(() => import("./pages/Register"));

// Check fo and initialize axios
const token = checkAuth();

function App() {
  // useEffect(() => {
  //   // 👆 daisy UI themes initialization
  //   themeChange(false)
  // }, [])

  return (
    <>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/register" element={<Register />} />

          {/* Place new rs over this */}
          <Route path="/app/*" element={<Layout />} />

          <Route
            path="*"
            element={
              <Navigate to={token ? "/app/dashboard" : "/login"} replace />
            }
          />
        </Routes>
      </Router>
      {/* Add ToastContainer here */}
      <ToastContainer
        position="top-right" // Position of toasts
        autoClose={3000} // Auto close duration in milliseconds
        hideProgressBar={false} // Show/Hide progress bar
        newestOnTop={false} // Show newest toast on top
        closeOnClick // Close toast on click
        rtl={false} // Right-to-left support
        pauseOnFocusLoss // Pause timer when focus is lost
        draggable // Allow dragging to dismiss toast
        pauseOnHover // Pause timer on hover
        theme="colored" // Theme of the toast
      />
    </>
  );
}

export default App;
